/*
 * @Author: Gang Jiang 
 * @Date: 2024-09-14 14:59:45 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2026-05-27 18:21:26
 * Copy from web_h5_nuxt
 */
import axios from "axios";
import { apiDomain } from "../../config";

// 创建实例
const service = axios.create({
  timeout: 10000
})

const prefix = process.env.NODE_ENV === 'production' ? location.origin.replace('adm', 'api') : '/api';

/** 解析含域名的完整请求地址（开发环境 /api 会映射到 config.apiDomain） */
function resolveFullUrl(url) {
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('/api')) {
    return `https://${apiDomain}${url.replace(/^\/api/, '')}`;
  }
  if (url.startsWith('/')) {
    return `${location.origin}${url}`;
  }
  return url;
}

/**
 * 添加请求拦截器
 */
service.interceptors.request.use(
  config => {
    if (config.url.indexOf('/api/storage') === -1) {
      config.url = prefix + '/admin/influencer-marketing/v1/' + config.url;
    }
    const method = (config.method || 'get').toUpperCase();
    console.log(`[influencer-admin API] ${method} ${resolveFullUrl(config.url)}`);
    config.headers['x-dm-token'] = localStorage.getItem('adminToken') && localStorage.getItem('adminToken').split('|')[1];
    return config;
  },
  error => {
    //请求错误时做些事
    return Promise.reject(error);
  }
);

export default service;
